import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import { treatExperiment } from 'src/app/shared/api/experiments';
import { isMobile } from 'src/app/shared/utils/userAgent';

type Experiment = {
	experimentName: string;
	variation: 'control' | 'fake_control' | 'variant1';
	treated: boolean;
};

type Params = {
	experiment: Experiment;
	utilityContext: UtilityContext;
};

export async function normalizePlatypusPetitionSignGooglePrefillExperiment({
	experiment,
	utilityContext,
}: Params): Promise<Experiment['variation']> {
	if (shouldRunExperiment({ experiment, utilityContext })) {
		await treatExperiment(utilityContext, experiment.experimentName);
		return experiment.variation;
	}
	return 'control';
}

function shouldRunExperiment({ experiment, utilityContext }: Params): boolean {
	return isEnabledByFC(experiment) && isMobile(utilityContext);
}

/**
 * If there is no FCM, or the experiment name in the FCM is empty or invalid,
 * the experimentName property from GraphQL is set to '__invalid_experiment__' per the configuration in
 * packages/experiments/src/configs/configs/platypus_petition_sign_google_prefill_experiment.ts
 */
function isEnabledByFC(experiment: Experiment): boolean {
	return experiment.experimentName !== '__invalid_experiment__';
}
